import PageLayout from '@/components/feature/PageLayout';
import { usePageSEO } from '@/hooks/usePageSEO';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestWorks from './components/LatestWorks';
import HotTutorials from './components/HotTutorials';
import HotTopics from './components/HotTopics';
import IntroSection from './components/IntroSection';

export default function Home() {
  usePageSEO({
    title: '无节操摄影部 - 创意摄影作品展示与社区交流平台',
    description:
      '无节操摄影部是一个专注于创意与趣味摄影的交流平台，汇聚多样摄影作品和专业讨论，帮助摄影爱好者展示作品与提升技能。',
    keywords: '无节操摄影部,摄影社区,创意摄影,摄影作品展示,摄影交流,摄影技巧,摄影爱好者',
  });

  return (
    <PageLayout>
      <h1 className="sr-only">无节操摄影部 - 创意摄影作品展示与社区交流平台</h1>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestWorks />
      <HotTutorials />
      <HotTopics />
      <IntroSection />
    </PageLayout>
  );
}